import React from 'react'
import styled from 'styled-components';
import { useState, useEffect, useRef } from 'react';
import JoditEditor from 'jodit-react';
import { useSelector } from 'react-redux'
import useAuth from '../../../../features/hooks/useAuth'
import { useGetAssetMastersQuery } from '../../../../features/assetmasterApiSlice/assetmasterApiSlice'
import { useGetassetReqQuery, useUpdateassetReqMutation, useUpdateassetReqstatusMutation, useUpdateReqPartialIssueMutation, useUpdateReqIssuerMutation } from '../../../../features/assetrequest/assetReqApiSlice'
import { useGetUsersQuery, useAddUserAssetsMutation } from '../../../../features/users/usersApiSlice';
import { useGetofficesQuery } from '../../../../features/offices/officesApiSlice';
import { useGetAssetsFinalQuery, useUpdateAddAssetFinalMutation, useUpdateAssetintransitMutation } from '../../../../features/addassets/addassetfinalApiSlice'
import Divider from '@mui/material/Divider';
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';
import { useGetStoreOfficesQuery } from '../../../../features/storeoffices/storeofficesApiSlice'
import CustomPaginationActionsTable from './AllstoreAssetsTableAML1'
import ReqCreatorOffAssetsTable from './ReqCreatorOffAssetsTable';
import ReactTooltip from "react-tooltip";
import moment from 'moment'
import Popup from 'reactjs-popup';
import TextField from '@mui/material/TextField';
import 'reactjs-popup/dist/index.css';
import { HeadingWrap, Span, CommonButton, PreDataWrap, IntReqWrapper, AddRemarkButton, BackButtonSpan, StoreNameCont, ExtReqWrapper, PopupButton } from '../../../../Styles/CommonStyles'


const Container = styled.div``
const Wrapper = styled.div`
display: flex;
flex-direction: column;
`
const AssetWrapper = styled.div``
const AssetItemWrapper = styled.div`
display: flex;
margin: 10px;
align-items: center;
font-size: 20px;
`
const AssetItemsWrap = styled.span`
margin-right: 30px;
font-size: 20px;
`
const TextWrapper = styled.div`
font-size: 20px;
`
const UserNameContainer = styled.div`
padding-right: 30px;
font-size: 20px;
`
const PreDataCont = styled.div`
`
const FormContainer = styled.div``
const FormWrapper = styled.div``
const AssetFormContainer = styled.div`
`
const AssetFormWrapper = styled.div``
const TextFormCont = styled.div``

const FormItemsCont = styled.div`
display: flex;
align-items: center;
`
const InputFieldWrap = styled.div``
const SelectContainer = styled.div`
display: flex;
align-items: center;
`
const Option = styled.option`
font-weight: 100;
`
const Styledlabel = styled.label`
font-size: 20px;
font-weight: 200;
`
const CatSelect = styled.select`
width: 30%;
height: 35px;
`
const SubcatSelect = styled.select`
width: 30%;
height: 30px;
`
const AssetNameselCon = styled.div`
display: flex;
height: 5vh;
`
const AssetDetailsText = styled.div``
const AddButton = styled.button``
const RemoveButton = styled.button``
const SubmitButton = styled.button``
const SenttoUnitHeadButton = styled(CommonButton)``
const SendtoAssetManL1Button = styled(CommonButton)``
const SendtoAssetManL2Button = styled(CommonButton)``
const ButtonContainer = styled.div`
display: flex;
align-items: center;
justify-content: space-between;
`
const TimeAndNameCont = styled.div`
display: flex;
font-size: 20px;
justify-content: space-between;
`
const TimeWrapper = styled.div`
font-size: 20px;
`
const NoteCountCont = styled.div`
font-size: 22px;
font-weight: 600;
`
const Approvedbutton = styled(CommonButton)``

const ApprovedAssetCont = styled.div`
display: flex;
`

const ApprovedAseetWrap = styled.div``

const ApprovedItemsCon = styled.div``

const IssueButton = styled(CommonButton)`
display: flex;
align-items: center;
justify-content: center;
width: 5vw;
height: 30px;
background-color: teal;
margin-right: 30px;
cursor: pointer;
border-radius: 10px; 
`
const CreateIssueButton = styled(CommonButton)``
const BackArrowContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-right: 20px;
  cursor: pointer;
`
const OldAssetsCont = styled.div``
const OldAssetWrapper = styled.div`
display: flex;
`
const OldItemsWrapper = styled.div`
display: flex;
margin-right: 40px;
margin-bottom: 20px;
`
const CurrSelAssetsCont = styled.div``
const ModifySelectedAssetsButton = styled(CommonButton)``

const SenttouserButton = styled(CommonButton)``
const RejectEnablerButton = styled(CommonButton)``

const AllStoreAssetsTableCont = styled.div``
const StyledPopup = styled(Popup)`
  // use your custom style for ".popup-content"
  &-content {
    margin: auto;
  background: rgb(255, 255, 255);
  width: 60%;
  padding: 5px;}
`
const ItemContainer = styled.div`
display: flex;
background-color: #aae2e4;
width: 50vw;
align-items: center;
justify-content: space-between;
margin-top: 20px;
margin-bottom: 2px;
padding-top: 5px;
padding-bottom: 5px;
`
const Itemwrapper = styled.div`
display: flex;
width: 14vw;
`
const ItemLabelwrap = styled.div`
font-weight: 600;
margin-right: 30px;
font-size: 25px;
`
const ItemValWarap = styled.div`
display: flex;
flex: 1;
justify-content: center;
align-items: center;
font-size: 20px;
`
const ApprAssetLeftwrap = styled.div`
flex: 1;
`

const ApprAssetRightwrap = styled.div`
flex: 3;
margin-left: 15px;
`
const PartialOptCont = styled.div``
const ParkedOptCont = styled.div``
const ReqOptCont = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-around;
`
const ReqOptLeftWrap = styled.div`
display: flex;
flex-direction: column;
align-items: center;
justify-content: center;
`
const ReqOptRightWrap = styled.div`
display: flex;
flex-direction: column;
align-items: center;
justify-content: center;
`
const RemarkCont = styled.div`
margin-top: 40px;
`
const PartialorParkreqWrap = styled.div``

const RemainAssetsProcCont = styled.div``
const RemainAssetsProcWrap = styled.div``
const ProcAllItemCont = styled.div`
display: flex;
margin-bottom:10px;
`
const ProcItemWrap = styled.div``

// table style
const tableStyle = {
    width: '53%',
    borderCollapse: 'collapse',
    marginTop: '20px',
};

const thTdStyle = {
    border: '1px solid #ddd',
    padding: '8px',
    textAlign: 'left',
    fontSize: '20px'
};

const thStyle = {
    backgroundColor: '#aae2e4',
    fontSize: '23px'
};

const evenRowStyle = {
    backgroundColor: '#f9f9f9',
};

const AMinboxForm = ({ reqid, setChangepage }) => {
    const [field, setField] = useState([{ catName: "", assetName: "", quantity: "" }])
    const [CatIndex, setCatIndex] = useState([])
    const [content, setContent] = useState('');
    const [remarkButtonClicked, setRemarkButtonClicked] = useState(false)
    const editor = useRef(null);
    const [issueClicked, setIssueClicked] = useState(false)
    const [selectedOptions, setSelectedOptions] = useState({});
    const [storeOffice, setStoreOffice] = useState('')
    const [remarks, setRemarks] = useState()
    const [procAssets, setProcAssets] = useState([])

    // logged in user info
    const { id, email, designation, designationSuffix, numSuffix, office, roles } = useAuth()
    let user_current_office = (useSelector((state) => state.office.off))
    let user_current_role_array = roles[user_current_office]

    // store offices 
    const {
        data: allstoreoffices
    } = useGetStoreOfficesQuery('allstorelists', {
        refetchOnFocus: true,
        refetchOnMountOrArgChange: true
    });

    let tempstoredata = allstoreoffices ? Object.values(allstoreoffices?.entities) : []
    let allstoresdata = tempstoredata

    //assetmaster call
    const {
        data: assetmasters,
        isLoading: assetmastLoad,

    } = useGetAssetMastersQuery('assetmasterlist', {
        refetchOnFocus: true,
        refetchOnMountOrArgChange: true
    });

    let tempdata = assetmasters ? Object.values(assetmasters?.entities) : []
    let data = tempdata

    //All assets in store
    const {
        data: allassets,
        isLoading,
        isSuccess,
        isError,
        error
    } = useGetAssetsFinalQuery('allassetlist', {
        refetchOnFocus: true,
        refetchOnMountOrArgChange: true
    });

    let allAssetsData = allassets ? Object.values(allassets?.entities) : []

    //get single assets
    const { getSingleasset } = useGetAssetsFinalQuery('allassetlist', {
        selectFromResult: ({ data }) => ({
            getSingleasset: data?.entities
        }),
    })

    // all users call 
    const {
        data: usersdata,
        isLoading: usersLoading,

    } = useGetUsersQuery('userslist', {
        refetchOnFocus: true,
        refetchOnMountOrArgChange: true
    });

    let users = usersdata ? Object.values(usersdata?.entities) : []

    //Single user call
    const { getSingleuser } = useGetUsersQuery('userslist', {
        selectFromResult: ({ data }) => ({
            getSingleuser: data?.entities
        }),
    })

    //Single Request call
    const { getSingleRequest } = useGetassetReqQuery('allassetReqlist', {
        selectFromResult: ({ data }) => ({
            getSingleRequest: data?.entities
        }),
    })

    //call the req doc which is clicked
    let singleReq_data = getSingleRequest && getSingleRequest[reqid]

    //Asset_managers call/filter
    let store_off = singleReq_data?.req_store

    //set selected store office
    useEffect(() => {
        setStoreOffice(store_off)
    }, [])

    //find applicable categories based on store of the request
    let selectedStoreDoc = allstoresdata.filter(elm => elm.storeoffice === store_off)
    let applCatarray = selectedStoreDoc[0]?.ApplAssetCateg

    //get last assets blocked by assetmanager level-1
    //first find lastindex
    let lastblockedassetind = singleReq_data?.req_data.findLastIndex(elm => elm.blocked_assets)
    let lastblockedassetsObj = singleReq_data?.req_data[lastblockedassetind]
    let lastBlockedAssetsArray = lastblockedassetsObj?.blocked_assets

    //all office call
    const {
        data: allofficedata,
        isLoading: allofficeLoad,
    } = useGetofficesQuery('officelist', {
        refetchOnFocus: true,
        refetchOnMountOrArgChange: true
    });

    //reqUpdate mutation
    const [updateReq, { isLoading: updateaddassetloading }] = useUpdateassetReqMutation()

    //reqStatus Update Mutation
    const [updateReqStatus, { isLoading: updateaddassetreqStatusloading }] = useUpdateassetReqstatusMutation()

    // update request for partial asset allocation
    const [updateReqParialIssue, { isLoading: updateaParialIssueloading }] = useUpdateReqPartialIssueMutation()

    //updateissuer in req
    const [updateIssuer, { isLoading: updateIssuerloading }] = useUpdateReqIssuerMutation()

    let tempallofficedata = allofficedata ? Object.values(allofficedata?.entities) : []
    const officedata = tempallofficedata

    //get last selected assets by user 
    let index_last_assets = getSingleRequest[reqid]?.req_data.findLastIndex(elm => elm.assets_details !== undefined)
    let lastSubAssetArray = getSingleRequest[reqid]?.req_data[index_last_assets].assets_details

    //selcted assets IDs array
    let selectedAssetsIdArray = Object.values(selectedOptions)?.map(elm => elm?.map((elem) => { return elem.value })).flat()
    let selectedassets = selectedAssetsIdArray?.map(elm => { return getSingleasset && getSingleasset[elm] })

    //validator for assetQuantity
    let totalAssetsQuantity = lastSubAssetArray.map(elm => { return Number(elm.quantity) }).reduce((a, b) => a + b, 0)

    //logic for modifying the assets
    let lastAssets = lastBlockedAssetsArray?.map(elm => { return getSingleasset && getSingleasset[elm] })
    let lastAssetssub = structuredClone(lastAssets)

    useEffect(() => {
        if ((singleReq_data?.sent_to_tag === 'level_1_approver') && (["modify_assets"].includes(singleReq_data?.curr_status))) {

            let transformedObject = lastAssetssub?.reduce((acc, item) => {
                let key = item?.name; // Use 'name' as the key
                if (!acc[key]) {
                    acc[key] = []; // Initialize the array for this key if not exists
                }
                acc[key].push({ value: item?._id, label: item?.oem_tag });
                return acc;
            }, {});
            setSelectedOptions(transformedObject)
        }
    }, [remarkButtonClicked])

    // sent back to unithead  
    // find unit head id of useroffice (request creator office)
    let useroffice = officedata?.filter(elm => elm.name === singleReq_data?.req_creator.office)
    let unitHead_id = useroffice[0]?.unitHead
    let requestCreatorOff = singleReq_data?.req_creator.office

    let sendtounitHeadObj = { id: unitHead_id, name: getSingleuser && getSingleuser[unitHead_id]?.name, office: requestCreatorOff, designation: getSingleuser && getSingleuser[unitHead_id]?.designation[requestCreatorOff], designationSuffix: getSingleuser && getSingleuser[unitHead_id]?.designationSuffix[requestCreatorOff], numSuffix: getSingleuser && getSingleuser[unitHead_id]?.numSuffix[requestCreatorOff] }

    let senttounitHeadUpdateData =
    {
        sent_to_tag: 'unithead',
        Text: content,
        sent_by: { id: id, name: getSingleuser && getSingleuser[id]?.name, office: user_current_office, designation: designation[user_current_office], designationSuffix: designationSuffix[user_current_office], numSuffix: numSuffix[user_current_office] },
        sent_to: sendtounitHeadObj,
        status: singleReq_data?.curr_status,
        time_stamp: new Date()
    }

    // sendto Assetmanager level -2 obj logic building
    // find asset manager level-II ID
    let assetManagerL2Id = selectedStoreDoc[0]?.roleUsers.level2approver
    //sent to Assetmanager level-II obj
    let sendtoassetManagerL2Obj = { id: assetManagerL2Id, name: getSingleuser && getSingleuser[assetManagerL2Id]?.name, office: user_current_office, designation: getSingleuser && getSingleuser[assetManagerL2Id]?.designation[user_current_office], designationSuffix: getSingleuser && getSingleuser[assetManagerL2Id]?.designationSuffix[user_current_office], numSuffix: getSingleuser && getSingleuser[assetManagerL2Id]?.numSuffix[user_current_office] }

    // sent to assetmanager level-II buttton data
    let senttoassetmanagerL2UpdateData =
    {
        sent_to_tag: 'level_2_approver',
        blocked_assets: selectedAssetsIdArray,
        Text: content,
        sent_by: { id: id, name: getSingleuser && getSingleuser[id]?.name, office: user_current_office, designation: designation[user_current_office], designationSuffix: designationSuffix[user_current_office], numSuffix: numSuffix[user_current_office] },
        sent_to: sendtoassetManagerL2Obj,
        status: singleReq_data?.curr_status,
        time_stamp: new Date()
    }

    //sent back to assetmanager level-I obj
    // find asset manager level-I ID
    let assetManagerL1Id = selectedStoreDoc[0]?.roleUsers.level1approver

    //sent to Assetmanager level-1 obj
    let sendtoassetManagerL1Obj = { id: assetManagerL1Id, name: getSingleuser && getSingleuser[assetManagerL1Id]?.name, office: user_current_office, designation: getSingleuser && getSingleuser[assetManagerL1Id]?.designation[user_current_office], designationSuffix: getSingleuser && getSingleuser[assetManagerL1Id]?.designationSuffix[user_current_office], numSuffix: getSingleuser && getSingleuser[assetManagerL1Id]?.numSuffix[user_current_office] }

    let senttoassetmanagerL1UpdateData =
    {
        sent_to_tag: 'level_1_approver',
        Text: content,
        sent_by: { id: id, name: getSingleuser && getSingleuser[id]?.name, office: user_current_office, designation: designation[user_current_office], designationSuffix: designationSuffix[user_current_office], numSuffix: numSuffix[user_current_office] },
        sent_to: sendtoassetManagerL1Obj,
        time_stamp: new Date()
    }

    //senttoUser object for sending issued assets to the user.
    //find the user ID of request creator
    // filter users in the office of request creator
    let requestCreatorofficeuserslist = users?.filter(elm => ((elm.office.mainCharge === singleReq_data?.req_creator.office) || (elm.office.additionalCharge.includes(singleReq_data?.req_creator.office))))

    // filter the request creator
    let reqCreatorobj = requestCreatorofficeuserslist?.filter(elm => (elm.designation[singleReq_data?.req_creator.office] === singleReq_data?.req_creator.designation) && (elm.designationSuffix[singleReq_data?.req_creator.office] === singleReq_data?.req_creator.designationSuffix) && (elm.numSuffix[singleReq_data?.req_creator.office] === singleReq_data?.req_creator.numSuffix))
    let reqCreator_id = reqCreatorobj[0]?._id

    let senttoUserObj = { id: reqCreator_id, name: getSingleuser && getSingleuser[reqCreator_id]?.name, office: requestCreatorOff, designation: getSingleuser && getSingleuser[reqCreator_id]?.designation[requestCreatorOff], designationSuffix: getSingleuser && getSingleuser[reqCreator_id]?.designationSuffix[requestCreatorOff], numSuffix: getSingleuser && getSingleuser[reqCreator_id]?.numSuffix[requestCreatorOff] }

    let senttouserUpdateData =
    {
        sent_to_tag: 'user',
        Text: content,
        sent_by: { id: id, name: getSingleuser && getSingleuser[id]?.name, office: user_current_office, designation: designation[user_current_office], designationSuffix: designationSuffix[user_current_office], numSuffix: numSuffix[user_current_office] },
        sent_to: senttoUserObj,
        status: singleReq_data?.curr_status,
        time_stamp: new Date()
    }

    // all sent to update body
    let senttounitHeadBody = { id: reqid, senttounitHeadUpdateData: senttounitHeadUpdateData }
    let senttoassetmanagerL1Body = { id: reqid, senttoassetmanagerL1UpdateData: senttoassetmanagerL1UpdateData }
    let senttoassetmanagerL2Body = { id: reqid, senttoassetmanagerL2UpdateData: senttoassetmanagerL2UpdateData }
    let senttouserBody = { id: reqid, senttouserUpdateData: senttouserUpdateData }

    //transbody
    //assets in transit status update call 
    const [updateAssetinTran, { isLoading: updateAssetinTranloading }] = useUpdateAssetintransitMutation()

    // assets in transit/ non-ransit logic based on blocked and unblocked assets by assetmanager level-1
    let oldassetsarray = lastBlockedAssetsArray
    let newselectedArray = selectedAssetsIdArray

    //filter old asset array which are not common in newselected
    let myArray = oldassetsarray?.filter((el) => !newselectedArray.includes(el));

    // body to update assets intransit status
    let updatedintransitbody = { selectedAssetarray: newselectedArray, transtatus: true }
    let notintransitassetarray = { selectedAssetarray: myArray, transtatus: false }

    //send back to unit head
    const sendtounitheadHandler = async () => {
        if (!unitHead_id) {
            return alert('unithead is not registered. Please register the unithead')
        }
        else {
            try {
                await updateReq(senttounitHeadBody)
                setChangepage([true, false, false, false])
                return alert('Send to unitHead')
            } catch (err) {
                return alert(`Error:${err}`)
            }
        }
    }

    //send back to assetmanager level-I 
    const senttoAssetManagerL1Handler = async () => {
        if (!assetManagerL1Id) {
            return alert('Asset Manager at level-I is not registered. Please register the Asset Manager at level-I')
        }
        else {
            try {
                await updateReq(senttoassetmanagerL1Body)
                setChangepage([true, false, false, false])
                return alert('send to Asset Manager Level-I')
            } catch (err) {
                return alert(`Error:${err}`)
            }
        }
    }

    // issued assets name array
    let issuedAssetsNameArray = selectedassets?.map(elm => elm?.name)
    const findOccurrences = (arr = []) => {
        const res = [];
        arr.forEach(el => {
            const index = res.findIndex(obj => {
                return obj['name'] === el;
            });
            if (index === -1) {
                res.push({
                    "name": el,
                    "count": 1
                })
            }
            else {
                res[index]["count"]++;
            };
        });
        return res;
    };
    // create issued assets names with count
    let nameArrayObj = findOccurrences(issuedAssetsNameArray)

    let issuedAssetsMap = {};
    nameArrayObj?.forEach(asset => {
        issuedAssetsMap[asset?.name?.trim()] = asset.count;
    });

    // Calculate remaining assets and remove objects with quantity 0
    //initial requested assets at the time of first partial issue will be lastsubAssetArray (lastsubmitted assets array) but in second time of parial issue the initail requested assets will be remaining_assets.
    let requestedAssets = singleReq_data?.remaining_assets ? structuredClone(singleReq_data?.remaining_assets) : structuredClone(lastSubAssetArray)
    let remainingAssets = requestedAssets?.map(asset => {
        let issuedCount = issuedAssetsMap[asset.assetName];
        if (issuedCount !== undefined) {
            asset.quantity -= issuedCount;
        }
        return asset;
    })?.filter(asset => asset.quantity > 0); // Remove objects with quantity 0

    // total quantity of remaining assets.
    let totalAssetsQuantityofReamaing = remainingAssets?.map(elm => { return Number(elm.quantity) }).reduce((a, b) => a + b, 0)

    //asset quantities changed of remaining assets for planning of procurement.
    let Remainassets = structuredClone(remainingAssets)

    useEffect(() => {
        setProcAssets(Remainassets)
    }, [totalAssetsQuantityofReamaing]);

    // handle procure plan assets change
    const handleQuantityChange = (index, event) => {
        let tempAssets = [...procAssets]
        tempAssets[index] = {
            ...tempAssets[index],
            quantity: event.target.value // Update the quantity of the specific asset
        };
        setProcAssets(tempAssets)
    }

    //Sent to user(request_creator)
    const senttouserHandler = async () => {
        if (!unitHead_id) {
            return alert('user is not registered. Please register the user or sent this request to unithead')
        }
        else {
            try {
                await updateReq(senttouserBody)
                setChangepage([true, false, false, false])
                return alert('Send to user')
            } catch (err) {
                return alert(`Error:${err}`)
            }
        }
    }

    //handle approve
    const handleApproveClick = async () => {
        if (singleReq_data?.curr_status === 'partialissue') {
            let updateStatusBody = { id: reqid, curr_status: totalAssetsQuantityofReamaing === 0 ? 'approved' : 'partialissueapproved' }
            try {
                await updateReqStatus(updateStatusBody)
                return alert('PartialApproved')
            } catch (err) {
                return alert(`Error:${err}`)
            }

        } else {
            let updateStatusBody = { id: reqid, curr_status: 'approved' }
            try {
                await updateReqStatus(updateStatusBody)
                return alert('Approved')
            } catch (err) {
                return alert(`Error:${err}`)
            }
        }
    }

    // change status to modify assets if needs
    let updatemodifyStatusBody = { id: reqid, curr_status: 'modify_assets' }
    const modifyAssetHandler = async () => {
        try {
            await updateReqStatus(updatemodifyStatusBody)
            return alert('Asset mofification enabled')
        } catch (err) {
            return alert(`Error:${err}`)
        }
    }

    // create Issue handler
    // add issuer 
    let issuerDetails = { id: id, office: user_current_office, designation: designation[user_current_office] }
    let issuerBody = { id: reqid, issuer: issuerDetails }
    const CreateIssueHandler = async () => {
        if (singleReq_data?.curr_status === 'partialissueapproved') {
            let IssueStatusBody = { id: reqid, curr_status: 'partialissuecreated' }
            try {
                await updateReqStatus(IssueStatusBody)
                await updateIssuer(issuerBody)
                return alert('Issue created')
            } catch (err) {
                return alert(`Error:${err}`)
            }
        }
        else {
            let IssueStatusBody = { id: reqid, curr_status: 'issued' }
            try {
                await updateReqStatus(IssueStatusBody)
                await updateIssuer(issuerBody)
                return alert('Issue created')
            } catch (err) {
                return alert(`Error:${err}`)
            }
        }
    }

    // status object reject handler
    let rejectionEnablerBody = { id: reqid, curr_status: 'rejetion_enabled' }
    const rejectEnabHandler = async () => {
        try {
            await updateReqStatus(rejectionEnablerBody)
            return alert('Request rejection enabled')
        } catch (err) {
            return alert(`Error:${err}`)
        }
    }

    //**************************No assets allocation/parking of req*******************************/
    // Req handler
    let updateParkStatusBody = { id: reqid, curr_status: 'reqParked' }
    // other updates
    const parkReqHandler = async () => {
        if (singleReq_data?.curr_status === 'partialissueaccepted') {
            if (remarks) {
                try {
                    await updateReqStatus(updateParkStatusBody)
                    setChangepage([true, false, false, false])
                    return alert('Request has been Parked')
                } catch (err) {
                    return alert(`Error:${err}`)
                }
            } else {
                return alert('Please provide some remarks for parking the request')
            }
        } else {
            let firsttimeparkReqBody = { req_assets: lastSubAssetArray, remaining_assets: lastSubAssetArray, plan_assets: procAssets, reqHandleReamarks: remarks, id: reqid }
            if (remarks) {
                try {
                    await updateReqStatus(updateParkStatusBody)
                    await updateReqParialIssue(firsttimeparkReqBody)
                    setChangepage([true, false, false, false])
                    return alert('Request has been Parked')
                } catch (err) {
                    return alert(`Error:${err}`)
                }
            } else {
                return alert('Please provide some remarks for parking the request')
            }
        }
    }

    //*******************Enabling the Partial Asset Allocation******************/
    let updatePartialStatusBody = { id: reqid, curr_status: 'partialissue' }
    // partial req handler
    const partialReqHandler = async () => {

        if (singleReq_data?.curr_status === 'partialissueaccepted') {
            if (remarks) {
                try {
                    await updateReqStatus(updatePartialStatusBody)
                    setRemarks('')
                    return alert('Again Partial asset allocation has been enabled')
                } catch (err) {
                    return alert(`Error:${err}`)
                }
            } else {
                return alert('Please provide some remarks for partial issue Enabling')
            }

        } else if (singleReq_data?.curr_status === 'reqParked') {
            let reqParktoPartailReqBody = { plan_assets: procAssets, reqHandleReamarks: remarks, id: reqid }
            if (remarks) {
                try {
                    await updateReqStatus(updatePartialStatusBody)
                    // await updateReqParialIssue(reqParktoPartailReqBody)
                    // setSelectedOptions([])
                    return alert('Partial asset allocation has been enabled')
                } catch (err) {
                    return alert(`Error:${err}`)
                }
            } else {
                return alert('Please provide some remarks for partial issue')
            }
        } else {

            // other updates
            let firsttimepartialReqBody = { req_assets: lastSubAssetArray, remaining_assets: lastSubAssetArray, plan_assets: procAssets, reqHandleReamarks: remarks, id: reqid }
            if (remarks) {
                try {
                    await updateReqStatus(updatePartialStatusBody)
                    // await updateReqParialIssue(firsttimepartialReqBody)
                    // setRemarks('')
                    // setSelectedOptions([])
                    return alert('Partial asset allocation has been enabled')
                } catch (err) {
                    return alert(`Error:${err}`)
                }
            } else {
                return alert('Please provide some remarks for partial issue')
            }
        }
    }

    // send to assetmanager level-II 
    //with this also in_transit status to change from false to true
    const senttoAssetManagerL2Handler = async () => {
        if (singleReq_data?.curr_status === 'partialissue') {
            if (totalAssetsQuantityofReamaing === 0) {
                if (assetManagerL2Id) {
                    let updateStatusBody = { id: reqid, curr_status: 'pending' }
                    let partialReqBody = { remaining_assets: remainingAssets, plan_assets: procAssets, reqHandleReamarks: remarks, id: reqid }
                    try {
                        await updateReq(senttoassetmanagerL2Body)
                        await updateReqStatus(updateStatusBody)
                        await updateAssetinTran(updatedintransitbody)
                        await updateAssetinTran(notintransitassetarray)
                        await updateReqParialIssue(partialReqBody)
                        setChangepage([true, false, false, false])
                        return alert('send to asset Manager level-2')
                    } catch (err) {
                        return alert(`Error:${err}`)
                    }
                } else {
                    return alert('Asset Manager at level-II is not registered. Please register the Asset Manager at level-II')
                }
            } else if (0 < totalAssetsQuantityofReamaing) {
                if (remarks) {
                    if (!assetManagerL2Id) {
                        return alert('Asset Manager at level-II is not registered. Please register the Asset Manager at level-II')
                    } else if (selectedAssetsIdArray.length === 0) {
                        return alert("Please select atleast one asset")
                    } else if (assetManagerL2Id && (0 < selectedAssetsIdArray.length)) {
                        let partialReqBody = { remaining_assets: remainingAssets, plan_assets: procAssets, reqHandleReamarks: remarks, id: reqid }
                        try {
                            await updateReq(senttoassetmanagerL2Body)
                            await updateAssetinTran(updatedintransitbody)
                            await updateAssetinTran(notintransitassetarray)
                            await updateReqParialIssue(partialReqBody)
                            setChangepage([true, false, false, false])
                            return alert('send to asset Manager level-2')
                        } catch (err) {
                            return alert(`Error:${err}`)
                        }
                    }
                } else { return alert('Please provide some remarks.') }
            }

        } else if (singleReq_data?.curr_status === 'reqParked') {
            if (totalAssetsQuantityofReamaing === 0) {
                if (!assetManagerL2Id) {
                    return alert('Asset Manager at level-II is not registered. Please register the Asset Manager at level-II')
                } else if (assetManagerL2Id) {
                    let updateRemakStatusBody = { id: reqid, curr_status: 'pending' }
                    let parkReqBody = { remaining_assets: remainingAssets, plan_assets: procAssets, reqHandleReamarks: remarks, id: reqid }
                    try {
                        await updateReq(senttoassetmanagerL2Body)
                        await updateReqStatus(updateRemakStatusBody)
                        await updateAssetinTran(updatedintransitbody)
                        await updateAssetinTran(notintransitassetarray)
                        await updateReqParialIssue(parkReqBody)
                        setChangepage([true, false, false, false])
                        return alert('send to asset Manager level-2')
                    } catch (err) {
                        return alert(`Error:${err}`)
                    }
                }
            } else if (0 < totalAssetsQuantityofReamaing) {
                return alert("Please select all asset or Enable the partial Issue")
            }
        } else {
            if (!assetManagerL2Id) {
                return alert('Asset Manager at level-II is not registered. Please register the Asset Manager at level-II')
            }
            else if (selectedAssetsIdArray.length !== totalAssetsQuantity) {
                return alert("Please select all asset or Enable the partial Issue/park Request")
            } else if (assetManagerL2Id && (selectedAssetsIdArray.length === totalAssetsQuantity)) {
                try {
                    await updateReq(senttoassetmanagerL2Body)
                    await updateAssetinTran(updatedintransitbody)
                    await updateAssetinTran(notintransitassetarray)
                    setChangepage([true, false, false, false])
                    return alert('send to asset Manager level-2')
                } catch (err) {
                    return alert(`Error:${err}`)
                }
            }
        }
    }

    // special validity of the case when partial request is accepted and again being sent from AMlevel-1
    let validate = !(user_current_role_array.includes('level1approver') && singleReq_data?.sent_to_tag
        === 'level_2_approver' && singleReq_data?.curr_status === 'partialissue')

    //***************************************************************************************************/
    return (
        <Container>
            <BackArrowContainer onClick={() => setChangepage([true, false, false, false])}><ArrowLeftIcon /><BackButtonSpan> Back to Category Table</BackButtonSpan></BackArrowContainer>
            <div className="dropdown-container" style={{ width: '200px' }}>
                <StyledPopup
                    trigger={
                        <PopupButton style={{ width: 200 }} className="button"> Request creator Office assets </PopupButton>}
                    modal
                    nested
                    contentStyle={{ maxHeight: '90%', overflowY: 'auto' }}
                >
                    <AllStoreAssetsTableCont>
                        <ReqCreatorOffAssetsTable requestCreatorOff={requestCreatorOff} />
                    </AllStoreAssetsTableCont>
                </StyledPopup>
            </div>
            {user_current_role_array.includes('level2approver') && <div className="dropdown-container" style={{ width: '200px' }}>
                <StyledPopup
                    trigger={
                        <PopupButton style={{ width: 200 }} className="button"> View All Store Assets </PopupButton>}
                    modal
                    nested
                    contentStyle={{ maxHeight: '90%', overflowY: 'auto' }}
                >
                    <AllStoreAssetsTableCont>
                        <CustomPaginationActionsTable />
                    </AllStoreAssetsTableCont>
                </StyledPopup>
            </div>}
            <AddRemarkButton onClick={() => setRemarkButtonClicked(true)}>Add Remark</AddRemarkButton>
            <Wrapper>
                <PreDataCont>
                    {getSingleRequest[reqid]?.req_data?.map((elm, ind) =>
                        <PreDataWrap key={ind}>
                            <HeadingWrap>
                                <NoteCountCont>Note-{ind + 1}</NoteCountCont>
                            </HeadingWrap>
                            {elm.assets_details && <div style={{ margin: '15px' }}><span style={{ fontSize: '20px' }}>Requested Asset Details:</span></div>}
                            {elm.assets_details && elm.assets_details?.map((elem, index) => <AssetItemWrapper key={index}>
                                <ItemContainer>
                                    <Itemwrapper>
                                        <ItemLabelwrap>
                                            Category:
                                        </ItemLabelwrap>
                                        <ItemValWarap>
                                            {elem.catName}
                                        </ItemValWarap>
                                    </Itemwrapper>
                                    <Itemwrapper>
                                        <ItemLabelwrap>
                                            AssetName:
                                        </ItemLabelwrap>
                                        <ItemValWarap>
                                            {elem.assetName}
                                        </ItemValWarap>
                                    </Itemwrapper>
                                    <Itemwrapper>
                                        <ItemLabelwrap>
                                            Quantity:
                                        </ItemLabelwrap>
                                        <ItemValWarap>
                                            {elem.quantity}
                                        </ItemValWarap>
                                    </Itemwrapper>
                                </ItemContainer>
                                <Divider />
                            </AssetItemWrapper>)}
                            {elm.blocked_assets && getSingleasset && <OldAssetsCont>
                                <Span> Proposed assets details: </Span>
                                {elm.blocked_assets && <OldAssetWrapper>
                                    <table style={tableStyle}>
                                        <thead>
                                            <tr>
                                                <th style={{ ...thTdStyle, ...thStyle }}>Assets</th>
                                                <th style={{ ...thTdStyle, ...thStyle }}>OEM Tags</th>
                                                <th style={{ ...thTdStyle, ...thStyle }}>OEM/Brand</th>
                                                <th style={{ ...thTdStyle, ...thStyle }}>Purchase Date</th>
                                                <th style={{ ...thTdStyle, ...thStyle }}>Warranty Date</th>
                                                <th style={{ ...thTdStyle, ...thStyle }}>Specifications</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {elm.blocked_assets?.map(element => { return getSingleasset && getSingleasset[element] })?.map((row, index) => (
                                                <tr key={index} style={(index + 1) % 2 === 0 ? evenRowStyle : null}>
                                                    <td style={thTdStyle}>{row.name}</td>
                                                    <td style={thTdStyle}>{row.oem_tag}</td>
                                                    <td style={thTdStyle}>{row.oem}</td>
                                                    <td style={thTdStyle}>{moment(row.purchase_date).format('DD/MM/YYYY')}</td>
                                                    <td style={thTdStyle}>{moment(row.warrantyexp_date).format('DD/MM/YYYY')}</td>
                                                    <td style={thTdStyle}><div className="App">
                                                        <div data-tip data-for={row._id}>
                                                            Hover here to view Specifications
                                                        </div>
                                                        <ReactTooltip id={row._id} place="top" effect="solid">
                                                            <div>
                                                                {Object.entries(row.specification).map(([key, val]) => <h4 key={key}>{key}: {val}</h4>)}
                                                            </div>
                                                        </ReactTooltip>
                                                    </div></td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </OldAssetWrapper>}
                            </OldAssetsCont>}
                            <TextWrapper>
                                Remark: <div dangerouslySetInnerHTML={{ __html: elm.Text }} />
                            </TextWrapper>
                            <TimeAndNameCont>
                                <TimeWrapper>
                                    {getSingleRequest[reqid]?.req_data[getSingleRequest[reqid]?.req_data.length - 1].time_stamp}
                                </TimeWrapper>
                                <UserNameContainer>
                                    {`${getSingleRequest[reqid]?.req_data[ind].sent_by?.name?.firstName} ${getSingleRequest[reqid]?.req_data[ind].sent_by?.name?.middleName} ${getSingleRequest[reqid]?.req_data[ind].sent_by?.name?.lastName}-${getSingleRequest[reqid]?.req_data[ind].sent_by?.office}-${getSingleRequest[reqid]?.req_data[ind].sent_by?.designation} ${getSingleRequest[reqid]?.req_data[ind].sent_by?.designationSuffix}`}
                                </UserNameContainer>
                            </TimeAndNameCont>
                        </PreDataWrap>)}
                </PreDataCont>
                {remarkButtonClicked && <FormContainer>
                    <FormWrapper>
                        {/* assets which are approved */}
                        {(singleReq_data?.sent_to_tag === 'level_1_approver') && (['approved', 'partialissueapproved'].includes(singleReq_data?.curr_status)) && <OldAssetsCont>
                            <Span> Issue to be created for following approved assets : </Span>
                            {lastBlockedAssetsArray.length && <OldAssetWrapper>
                                <table style={tableStyle}>
                                    <thead>
                                        <tr>
                                            <th style={{ ...thTdStyle, ...thStyle }}>Assets</th>
                                            <th style={{ ...thTdStyle, ...thStyle }}>OEM Tags</th>
                                            <th style={{ ...thTdStyle, ...thStyle }}>OEM/Brand</th>
                                            <th style={{ ...thTdStyle, ...thStyle }}>Purchase Date</th>
                                            <th style={{ ...thTdStyle, ...thStyle }}>Warranty Date</th>
                                            <th style={{ ...thTdStyle, ...thStyle }}>Specifications</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {lastBlockedAssetsArray?.map(element => { return getSingleasset && getSingleasset[element] })?.map((row, index) => (
                                            <tr key={index} style={(index + 1) % 2 === 0 ? evenRowStyle : null}>
                                                <td style={thTdStyle}>{row.name}</td>
                                                <td style={thTdStyle}>{row.oem_tag}</td>
                                                <td style={thTdStyle}>{row.oem}</td>
                                                <td style={thTdStyle}>{moment(row.purchase_date).format('DD/MM/YYYY')}</td>
                                                <td style={thTdStyle}>{moment(row.warrantyexp_date).format('DD/MM/YYYY')}</td>
                                                <td style={thTdStyle}><div className="App">
                                                    <div data-tip data-for={row._id}>
                                                        Hover here to view Specifications
                                                    </div>
                                                    <ReactTooltip id={row._id} place="top" effect="solid">
                                                        <div>
                                                            {Object.entries(row.specification).map(([key, val]) => <h4 key={key}>{key}: {val}</h4>)}
                                                        </div>
                                                    </ReactTooltip>
                                                </div></td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </OldAssetWrapper>}
                        </OldAssetsCont>}
                        {/* for issuing assets logic */}
                        <ApprovedAssetCont>
                            <ApprAssetLeftwrap>
                                {(singleReq_data?.sent_to_tag === 'level_1_approver') && (['reject_req', 'rejetion_enabled', 'issued', 'partialissue', 'reqParked', 'pending', "modify_assets"].includes(singleReq_data?.curr_status)) && <ApprovedAseetWrap>
                                    <Span>Select the assets: </Span>
                                    {lastSubAssetArray?.map((elm, ind) => (<ApprovedItemsCon key={ind}>
                                        <ItemContainer>
                                            <Itemwrapper>
                                                <ItemLabelwrap>
                                                    Category:
                                                </ItemLabelwrap>
                                                <ItemValWarap>
                                                    {elm.catName}
                                                </ItemValWarap>
                                            </Itemwrapper>
                                            <Itemwrapper>
                                                <ItemLabelwrap>
                                                    AssetName:
                                                </ItemLabelwrap>
                                                <ItemValWarap>
                                                    {elm.assetName}
                                                </ItemValWarap>
                                            </Itemwrapper>
                                            <Itemwrapper>
                                                <ItemLabelwrap>
                                                    Quantity:
                                                </ItemLabelwrap>
                                                <ItemValWarap>
                                                    {elm.quantity}
                                                </ItemValWarap>
                                            </Itemwrapper>
                                        </ItemContainer>
                                        <Divider sx={{ width: 950 }} />
                                        <div className="app">
                                            <h3>To Issue above Assets</h3>
                                            <div className="dropdown-container" style={{ width: '200px' }}>
                                                <StyledPopup
                                                    trigger={
                                                        <PopupButton style={{ width: 200 }} className="button"> Go to Store Assets </PopupButton>}
                                                    modal
                                                    nested
                                                    contentStyle={{ maxHeight: '90%', overflowY: 'auto' }}
                                                >
                                                    <AllStoreAssetsTableCont>
                                                        <CustomPaginationActionsTable selectedOptions={selectedOptions} setSelectedOptions={setSelectedOptions} name={elm.assetName} quantity={elm.quantity} lastBlockedAssetsArray={lastBlockedAssetsArray} reqHandlingStatus={singleReq_data?.curr_status} />
                                                    </AllStoreAssetsTableCont>
                                                </StyledPopup>
                                            </div>
                                        </div>
                                    </ApprovedItemsCon>))}
                                    <CurrSelAssetsCont>
                                        <Span> Selected Assets to be issued:</Span>
                                        <table style={tableStyle}>
                                            <thead>
                                                <tr>
                                                    <th style={{ ...thTdStyle, ...thStyle }}>Assets</th>
                                                    <th style={{ ...thTdStyle, ...thStyle }}>OEM Tags</th>
                                                    <th style={{ ...thTdStyle, ...thStyle }}>OEM/Brand</th>
                                                    <th style={{ ...thTdStyle, ...thStyle }}>Purchase Date</th>
                                                    <th style={{ ...thTdStyle, ...thStyle }}>Warranty Date</th>
                                                    <th style={{ ...thTdStyle, ...thStyle }}>Specifications</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {selectedassets?.map((row, index) => (
                                                    <tr key={index} style={(index + 1) % 2 === 0 ? evenRowStyle : null}>
                                                        <td style={thTdStyle}>{row?.name}</td>
                                                        <td style={thTdStyle}>{row?.oem_tag}</td>
                                                        <td style={thTdStyle}>{row?.oem}</td>
                                                        <td style={thTdStyle}>{moment(row?.purchase_date).format('DD/MM/YYYY')}</td>
                                                        <td style={thTdStyle}>{moment(row?.warrantyexp_date).format('DD/MM/YYYY')}</td>
                                                        <td style={thTdStyle}><div className="App">
                                                            <div data-tip data-for={row?._id}>
                                                                Hover here to view Specifications
                                                            </div>
                                                            <ReactTooltip id={row?._id} place="top" effect="solid">
                                                                <div>
                                                                    {Object.entries(row?.specification || {})?.map(([key, val]) => <h4 key={key}>{key}: {val}</h4>)}
                                                                </div>
                                                            </ReactTooltip>
                                                        </div></td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </CurrSelAssetsCont>
                                </ApprovedAseetWrap>}
                                {((['level_1_approver', 'user'].includes(singleReq_data?.sent_to_tag)) && (['partialissue', 'reqParked', 'partialissueaccepted'].includes(singleReq_data?.curr_status)) && <PartialorParkreqWrap>
                                    <ApprovedAseetWrap>
                                        <Span>Select the assets: </Span>
                                        {singleReq_data?.remaining_assets?.map((elm, ind) => (<ApprovedItemsCon key={ind}>
                                            <ItemContainer>
                                                <Itemwrapper>
                                                    <ItemLabelwrap>
                                                        Category:
                                                    </ItemLabelwrap>
                                                    <ItemValWarap>
                                                        {elm.catName}
                                                    </ItemValWarap>
                                                </Itemwrapper>
                                                <Itemwrapper>
                                                    <ItemLabelwrap>
                                                        AssetName:
                                                    </ItemLabelwrap>
                                                    <ItemValWarap>
                                                        {elm.assetName}
                                                    </ItemValWarap>
                                                </Itemwrapper>
                                                <Itemwrapper>
                                                    <ItemLabelwrap>
                                                        Quantity:
                                                    </ItemLabelwrap>
                                                    <ItemValWarap>
                                                        {elm.quantity}
                                                    </ItemValWarap>
                                                </Itemwrapper>
                                            </ItemContainer>
                                            <Divider sx={{ width: 950 }} />
                                            <div className="app">
                                                <h3>To Issue above Assets</h3>
                                                <div className="dropdown-container" style={{ width: '200px' }}>
                                                    <StyledPopup
                                                        trigger={
                                                            <PopupButton style={{ width: 200 }} className="button"> Go to Store Assets </PopupButton>}
                                                        modal
                                                        nested
                                                        contentStyle={{ maxHeight: '90%', overflowY: 'auto' }}
                                                    >
                                                        <AllStoreAssetsTableCont>
                                                            <CustomPaginationActionsTable selectedOptions={selectedOptions} setSelectedOptions={setSelectedOptions} name={elm.assetName} quantity={elm.quantity} lastBlockedAssetsArray={lastBlockedAssetsArray} reqHandlingStatus={singleReq_data?.curr_status} />
                                                        </AllStoreAssetsTableCont>
                                                    </StyledPopup>
                                                </div>
                                            </div>
                                        </ApprovedItemsCon>))}
                                        <CurrSelAssetsCont>
                                            <Span> Selected Assets to be issued:</Span>
                                            <table style={tableStyle}>
                                                <thead>
                                                    <tr>
                                                        <th style={{ ...thTdStyle, ...thStyle }}>Assets</th>
                                                        <th style={{ ...thTdStyle, ...thStyle }}>OEM Tags</th>
                                                        <th style={{ ...thTdStyle, ...thStyle }}>OEM/Brand</th>
                                                        <th style={{ ...thTdStyle, ...thStyle }}>Purchase Date</th>
                                                        <th style={{ ...thTdStyle, ...thStyle }}>Warranty Date</th>
                                                        <th style={{ ...thTdStyle, ...thStyle }}>Specifications</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {selectedassets?.map((row, index) => (
                                                        <tr key={index} style={(index + 1) % 2 === 0 ? evenRowStyle : null}>
                                                            <td style={thTdStyle}>{row.name}</td>
                                                            <td style={thTdStyle}>{row.oem_tag}</td>
                                                            <td style={thTdStyle}>{row.oem}</td>
                                                            <td style={thTdStyle}>{moment(row.purchase_date).format('DD/MM/YYYY')}</td>
                                                            <td style={thTdStyle}>{moment(row.warrantyexp_date).format('DD/MM/YYYY')}</td>
                                                            <td style={thTdStyle}><div className="App">
                                                                <div data-tip data-for={row._id}>
                                                                    Hover here to view Specifications
                                                                </div>
                                                                <ReactTooltip id={row._id} place="top" effect="solid">
                                                                    <div>
                                                                        {Object.entries(row.specification).map(([key, val]) => <h4 key={key}>{key}: {val}</h4>)}
                                                                    </div>
                                                                </ReactTooltip>
                                                            </div></td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </CurrSelAssetsCont>
                                    </ApprovedAseetWrap>
                                </PartialorParkreqWrap>)}
                            </ApprAssetLeftwrap>
                            {(['level_1_approver', 'user'].includes(singleReq_data?.sent_to_tag)) && (!['approved', 'issued', 'partialissueapproved', 'partialissuecreated'].includes(singleReq_data?.curr_status)) && <ApprAssetRightwrap>
                                <Span> For partial issue of assets or parking the request </Span>
                                {(['reqParked', 'partialissue'].includes(singleReq_data?.curr_status)) && <Span> {singleReq_data?.curr_status === 'reqParked' ? 'This request is currently parked' : 'Partial issue has already been enabled on this request'}  </Span>}
                                <ReqOptCont>
                                    <ReqOptLeftWrap>
                                        {(!['partialissue'].includes(singleReq_data?.curr_status)) && <PartialOptCont> <CommonButton onClick={partialReqHandler} > Enable partial Issue</CommonButton> </PartialOptCont>}
                                    </ReqOptLeftWrap>
                                    {(!['reqParked', 'partialissue'].includes(singleReq_data?.curr_status)) && <ReqOptRightWrap>
                                        <ParkedOptCont> <CommonButton onClick={parkReqHandler}> Park Request </CommonButton></ParkedOptCont>
                                    </ReqOptRightWrap>}
                                </ReqOptCont>
                                <RemarkCont>
                                    <TextField
                                        style={{ width: '700px' }}
                                        inputProps={{ style: { height: '38px' } }}
                                        value={remarks} name='remarks' onChange={(event) => {
                                            setRemarks(event.target.value);
                                        }} label="Please Provide Remarks for the above selected choice" size="small" variant="outlined" />
                                </RemarkCont>
                                {(singleReq_data?.sent_to_tag === 'level_1_approver') && <RemainAssetsProcCont>
                                    {totalAssetsQuantityofReamaing !== 0 && <Span>Plan assets in the Next Procuement cycle for this request </Span>}
                                    <RemainAssetsProcWrap>
                                        {procAssets?.map((elm, index) => (<ProcAllItemCont index={index}>
                                            <ProcItemWrap>
                                                <TextField
                                                    label="Category Name"
                                                    value={elm.catName}
                                                    disabled
                                                />
                                            </ProcItemWrap>
                                            <ProcItemWrap>
                                                <TextField
                                                    label="Asset Name"
                                                    value={elm.assetName}
                                                    disabled
                                                />
                                            </ProcItemWrap>
                                            <ProcItemWrap>
                                                <TextField
                                                    label="Quantity"
                                                    value={elm.quantity}
                                                    onChange={(event) => handleQuantityChange(index, event)}
                                                    type="number" // Allow only numeric input
                                                    InputProps={{ inputProps: { min: 0 } }} // Set minimum value to 0
                                                />
                                            </ProcItemWrap>
                                        </ProcAllItemCont>))
                                        }
                                    </RemainAssetsProcWrap>
                                </RemainAssetsProcCont>}
                            </ApprAssetRightwrap>}
                        </ApprovedAssetCont>
                        {validate && <TextFormCont>
                            <HeadingWrap><Span>Details/Justifications</Span></HeadingWrap>
                            <JoditEditor
                                ref={editor}
                                value={content}
                                onBlur={newContent => setContent(newContent)}
                                onChange={newContent => { }}
                            />
                        </TextFormCont>}
                    </FormWrapper>
                </FormContainer>}
                {remarkButtonClicked && <ButtonContainer>
                    {(singleReq_data?.sent_to_tag === 'level_1_approver') && (!['issued', 'approved', 'partialissuecreated'].includes(singleReq_data?.curr_status)) && <SenttoUnitHeadButton onClick={sendtounitheadHandler}>Send to Unit head</SenttoUnitHeadButton>}
                    {(singleReq_data?.sent_to_tag === 'level_2_approver') && validate && <SendtoAssetManL1Button onClick={senttoAssetManagerL1Handler}>Send to Asset Manager level-I </SendtoAssetManL1Button>}
                    {(singleReq_data?.sent_to_tag === 'level_2_approver') && (!['approved', 'partialissueapproved'].includes(singleReq_data?.curr_status)) && validate && <ModifySelectedAssetsButton onClick={modifyAssetHandler} >Enable Assets Modification</ModifySelectedAssetsButton>}
                    {(['level_1_approver', 'user'].includes(singleReq_data?.sent_to_tag)) && (!['issued', 'partialissuecreated'].includes(singleReq_data?.curr_status)) && <SendtoAssetManL2Button onClick={senttoAssetManagerL2Handler}>Send to Asset Manager level-II</SendtoAssetManL2Button>}
                    {singleReq_data?.sent_to_tag === 'level_2_approver' && (!['approved', 'partialissueapproved'].includes(singleReq_data?.curr_status)) && validate && <Approvedbutton onClick={handleApproveClick}>Approve</Approvedbutton>}
                    {(singleReq_data?.sent_to_tag === 'level_1_approver') && (['approved', 'partialissueapproved'].includes(singleReq_data?.curr_status)) && <CreateIssueButton onClick={CreateIssueHandler}>Create Issue</CreateIssueButton>}
                    {(singleReq_data?.sent_to_tag === 'level_1_approver') && (['issued', 'reject_req', 'partialissuecreated', 'rejetion_enabled'].includes(singleReq_data?.curr_status)) && <SenttouserButton onClick={senttouserHandler}> Send to user</SenttouserButton>}
                    {(singleReq_data?.sent_to_tag === 'level_1_approver') && (singleReq_data?.curr_status === 'reject_req') && <RejectEnablerButton onClick={rejectEnabHandler}>Enable rejection</RejectEnablerButton>}
                </ButtonContainer>}
            </Wrapper>
        </Container>
    )
}

export default AMinboxForm

